import { render, staticRenderFns } from "./Calidad.vue?vue&type=template&id=30a4c29e&scoped=true"
var script = {}
import style0 from "./Calidad.vue?vue&type=style&index=0&id=30a4c29e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a4c29e",
  null
  
)

export default component.exports